"use client";
import React, { useState } from "react";
import { LineChart } from "@carbon/charts-react";

const Fundamentals = () => {
  const gradient = "linear-gradient(to right, #FFA500 10%, #12AC21 50%)";

  const [valuationFilter, setValuationFilter] = useState("Overview");
  const handleValuationFilterClick = (valuation) => {
    setValuationFilter(valuation);
  };
  const [showMore, setShowMore] = useState(false);
  const points = [
    { label: "Lowest (2.18 30 June 2024)", position: 0 },
    { label: "Industry PE (16.5x)", position: 20 }, // example position
    { label: "Today (18.26x)", position: 40 }, // example position
    { label: "Highest (113.84x 30 June 2024)", position: 88 },
  ];

  const dataTrend = [
    {
      group: "PE Ratio",
      key: "Jan 2024",
      value: 35,
    },
    {
      group: "PE Ratio",
      key: "Feb 2024",
      value: 25,
    },
    {
      group: "PE Ratio",
      key: "Mar 2024",
      value: 32,
    },
    {
      group: "PE Ratio",
      key: "Apr 2024",
      value: 22,
    },
    {
      group: "PE Ratio",
      key: "May 2024",
      value: 30,
    },
    {
      group: "PE Ratio",
      key: "June 2024",
      value: 28,
    },

    {
      group: "Industry",
      key: "Jan 2024",
      value: 20,
    },
    {
      group: "Industry",
      key: "Feb 2024",
      value: 18,
    },
    {
      group: "Industry",
      key: "Mar 2024",
      value: 22,
    },
    {
      group: "Industry",
      key: "Ap 2024",
      value: 16,
    },
    {
      group: "Industry",
      key: "May 2024",
      value: 20,
    },
    {
      group: "Industry",
      key: "June 2024",
      value: 22,
    },
  ];
  const options = {
    // title: "Values in %",

    data: {
      selectedGroups: ["PE Ratio", "Industry"],
    },
    axes: {
      bottom: {
        // title: "2023 Annual Sales Figures",
        mapsTo: "key",
        scaleType: "labels",
      },
      left: {
        mapsTo: "value",
        // title: "Conversion rate",
        scaleType: "linear",
      },
    },
    height: "250px",
    legend: {
      position: "bottom",
      alignment: "center",
    },
    toolbar: {
      enabled: false,
    },
  };
  const dataPb = [
    {
      group: "PB Ratio",
      key: "Jan 2024",
      value: 2.42,
    },
    {
      group: "PB Ratio",
      key: "Feb 2024",
      value: 2.35,
    },
    {
      group: "PB Ratio",
      key: "Mar 2024",
      value: 1.31,
    },
    {
      group: "PB Ratio",
      key: "Apr 2024",
      value: 2.23,
    },
    {
      group: "PB Ratio",
      key: "May 2024",
      value: 1.23,
    },
    {
      group: "PB Ratio",
      key: "June 2024",
      value: 1.23,
    },

    {
      group: "Industry",
      key: "Jan 2024",
      value: 3.42,
    },
    {
      group: "Industry",
      key: "Feb 2024",
      value: 5.6,
    },
    {
      group: "Industry",
      key: "Mar 2024",
      value: 4.23,
    },
    {
      group: "Industry",
      key: "Ap 2024",
      value: 2.14,
    },
    {
      group: "Industry",
      key: "May 2024",
      value: 5.0,
    },
    {
      group: "Industry",
      key: "June 2024",
      value: 3.0,
    },
  ];

  const dataGross = [
    {
      group: "Gross NPA",
      key: "Jan 2024",
      value: 2.42,
    },
    {
      group: "Gross NPA",
      key: "Feb 2024",
      value: 2.35,
    },
    {
      group: "Gross NPA",
      key: "Mar 2024",
      value: 1.31,
    },
    {
      group: "Gross NPA",
      key: "Apr 2024",
      value: 2.23,
    },
    {
      group: "Gross NPA",
      key: "May 2024",
      value: 1.23,
    },
    {
      group: "Gross NPA",
      key: "June 2024",
      value: 1.23,
    },

    {
      group: "Net NPA",
      key: "Jan 2024",
      value: 3.42,
    },
    {
      group: "Net NPA",
      key: "Feb 2024",
      value: 5.6,
    },
    {
      group: "Net NPA",
      key: "Mar 2024",
      value: 4.23,
    },
    {
      group: "Net NPA",
      key: "Ap 2024",
      value: 2.14,
    },
    {
      group: "Net NPA",
      key: "May 2024",
      value: 5.0,
    },
    {
      group: "Net NPA",
      key: "June 2024",
      value: 3.0,
    },
  ];
  const optionsGross = {
    // title: "Values in %",

    data: {
      selectedGroups: ["Gross NPA", "Net NPA"],
    },
    axes: {
      bottom: {
        // title: "2023 Annual Sales Figures",
        mapsTo: "key",
        scaleType: "labels",
      },
      left: {
        mapsTo: "value",
        // title: "Conversion rate",
        scaleType: "linear",
      },
    },
    height: "250px",
    legend: {
      position: "bottom",
      alignment: "center",
    },
    toolbar: {
      enabled: false,
    },
  };

  const newsRes = [
    {
      text: "HDFC Bank | CMP: Rs 1,506 - Infosys, Bajaj Finance among 9 stocks that earned",
      NewsName: "Economicstimes",
      time: "2",
    },
    {
      text: "HUL, Tech Mahindra top gainers on Nifty50; HDFC Bank, Reliance most active",
      NewsName: "Businesstoday",
      time: "2",
    },
    {
      text: "Q4 Results Review: 5 cos including HDFC Bank, TCS contribute 75% to Nifty earnings growth; see top upgrades, downgrades",
      NewsName: "Livemint",
      time: "2",
    },
    {
      text: "HDFC Bank | CMP: Rs 1,506 - Infosys, Bajaj Finance among 9 stocks that earned",
      NewsName: "Economicstimes",
      time: "2",
    },
  ];
  const initialNewsToShow = 3;
  const newsToShow = showMore ? newsRes : newsRes.slice(0, initialNewsToShow);

  return (
    <div className="m-4">
      <p className="mb-4 font-bold text-2xl">Fundamentals</p>
      <div className="flex gap-4 mb-4">
        <div className="border border-solid border-[#E0E0E0] p-4 gap-4 w-[50%] h-max rounded-lg">
          <p className="font-semibold text-sm text-[#333333]">Valuation</p>
          <div className="flex justify-center items-center">
            <div className="flex justify-between items-center mt-4 rounded-full w-[35%] bg-[#F1F1F6]">
              <button
                className={`text-xs font-bold px-2 py-1 text-[#848484] ${
                  valuationFilter === "Overview"
                    ? "bg-[#A0FF77] !text-[#262626] rounded-full m-0.5 py-1"
                    : ""
                }`}
                onClick={() => handleValuationFilterClick("Overview")}
              >
                Overview
              </button>
              <button
                onClick={() => handleValuationFilterClick("Trend")}
                className={`text-xs font-bold px-2 py-1 text-[#848484] ${
                  valuationFilter === "Trend"
                    ? "bg-[#A0FF77] !text-[#262626] rounded-full m-0.5 py-1"
                    : ""
                }`}
              >
                Trend
              </button>
            </div>
          </div>
          {valuationFilter === "Trend" ? (
            <div className="mt-4">
              <LineChart data={dataTrend} options={options}></LineChart>
            </div>
          ) : valuationFilter === "Overview" ? (
            <div className="relative w-[370px] h-20 mt-[72px] ml-2 p-4">
              <div
                className="absolute top-1/2 rounded-full  transform -translate-y-1/2 w-full h-[10px]"
                style={{ background: gradient }}
              ></div>
              {points.map((point, index) => (
                <div
                  key={index}
                  className="absolute flex flex-col items-center"
                  style={{ left: `${point.position}%`, bottom: "48%" }}
                >
                  <span className="mb-8 text-[10px] w-[70px] font-bold text-[#333333] bg-[#F4EFEF] rounded p-[2px] text-center">
                    {point.label}
                  </span>
                  <div className="relative flex flex-col items-center -mb-[2px]">
                    <div className="absolute bottom-2 w-0.5 h-8 bg-gray-400"></div>
                    <div className="w-2 h-2 bg-gray-400 rounded-full "></div>
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </div>
        <div className="border border-solid border-[#E0E0E0] p-4 gap-4 w-[50%] h-max rounded-lg">
          <p className="font-semibold text-sm text-[#333333] mb-6">P/B Ratio</p>
          <LineChart data={dataPb} options={options}></LineChart>
        </div>
      </div>
      <div className="flex gap-4">
        <div className="border border-solid border-[#E0E0E0] w-[50%] h-max rounded-2xl p-4 flex flex-col gap-4 overflow-x-auto no-scrollbar">
          <p className="font-semibold text-sm text-[#333333]">
            Gross NPA & Net NPA
          </p>
          <LineChart data={dataGross} options={optionsGross}></LineChart>
        </div>{" "}
        {/* <div className="border border-solid border-[#E0E0E0] p-4 gap-4 w-[450px] h-max rounded-lg">
          <p className="font-semibold text-sm text-[#333333]">Shareholding</p>
        </div> */}
        <div className="border border-solid border-[#E0E0E0] p-4 gap-4 w-[50%] h-max rounded-lg">
          <p className="font-semibold text-sm text-[#333333] mb-6">News</p>
          <div className="flex flex-col items-center">
            {newsToShow.map((data) => (
              <div className="flex flex-col h-[71px] w-[420px] rounded-lg border border-solid py-2 px-3 mb-2 border-[#C3D5DC] gap-2">
                <div className="flex flex-row justify-between">
                  <p className="font-semibold text-xs text-[#848484]">
                    {data.NewsName}
                  </p>
                  <p className="font-semibold text-xs text-[#848484]">
                    {data.time} min ago
                  </p>
                </div>
                <p className="text-[#000000] font-medium text-xs">
                  {data.text}
                </p>
              </div>
            ))}
          </div>
          {!showMore && newsRes.length > initialNewsToShow && (
            <div className="flex flex-row gap-2 items-center pt-3 justify-center">
              <button
                className=" text-xs font-medium text-[#656565]"
                onClick={() => setShowMore(true)}
              >
                Show More
              </button>
              <img
                src="/images/rightArrow.png"
                alt=""
                className="w-[12px] h-[12px]"
              />
            </div>
          )}
        </div>
      </div>

      {/* ////////////////////////////////////////// */}
    </div>
  );
};

export default Fundamentals;
